import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import { i18n } from '@/helpers/i18n'
import VueApexCharts from 'vue-apexcharts'
import Multiselect from 'vue-multiselect'
import Toast from 'vue-toastification'
import axios from 'axios'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-toastification/dist/index.css'

import './print/print'
import './print/printFont'
import './print/printBarcode'
import '@/helpers/functions'
import '@/helpers/option'
import '@/helpers/user'
import '@/helpers/database'
import '@/helpers/deliveries'
import '@/helpers/users'
import '@/helpers/roles'
import '@/helpers/inputTable'
// import './registerServiceWorker'

Vue.config.productionTip = false
const token = localStorage.getItem('token')
const company = localStorage.getItem('company')

Vue.use(VueApexCharts)
Vue.use(CKEditor)
Vue.use(Toast, {
  position: 'top-center'
})
Vue.component('apexchart', VueApexCharts)
Vue.component('multiselect', Multiselect)
axios.defaults.headers.common['Authorization'] = token
axios.defaults.headers.common['company'] = company

new Vue({
  router,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
